import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#123f1e] text-white py-20 relative overflow-hidden">
      <div aria-hidden="true" className="absolute -z-10 top-0 right-0 w-96 h-96 bg-[#febc04]/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img
              src="/assets/images/home/gardenoflearning-logo.png"
              alt="Garden of Learning & Discovery logo"
              className="h-16 w-auto mb-6 brightness-0 invert opacity-90"
            />
            <h3 className="text-2xl font-bold mb-3 tracking-tight">
              Garden of Learning & Discovery
            </h3>
            <p className="text-white/70 mb-6 font-medium">
              District 9 Pre-K Center
            </p>
            <div className="flex gap-3">
              <a
                href="https://twitter.com/goldprekd9/"
                aria-label="Visit GoLD Pre-K on Twitter"
                className="w-11 h-11 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#febc04] hover:text-[#123f1e] transition-all duration-200"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
            </div>
          </div>

          <nav aria-label="Footer">
            <h4 className="text-lg font-bold mb-6 text-[#febc04]">Quick Links</h4>
            <ul className="space-y-3 font-medium">
              <li><a href="/" className="text-white/70 hover:text-[#febc04] transition-colors duration-200">Home</a></li>
              <li><a href="/about" className="text-white/70 hover:text-[#febc04] transition-colors duration-200">About Us</a></li>
              <li><a href="/enrollment" className="text-white/70 hover:text-[#febc04] transition-colors duration-200">Enrollment</a></li>
              <li><a href="/calendar" className="text-white/70 hover:text-[#febc04] transition-colors duration-200">Calendar</a></li>
            </ul>
          </nav>

          <div>
            <h4 className="text-lg font-bold mb-6 text-[#febc04]">Contact</h4>
            <div className="space-y-5 text-white/70 text-sm leading-relaxed font-medium">
              <div>
                <p className="font-bold text-white mb-1">4179 Third Ave.</p>
                <p>Bronx, NY 10457</p>
              </div>
              <div>
                <p className="font-bold text-white mb-1">1434 Ogden Ave.</p>
                <p>Bronx, NY 10452</p>
              </div>
              <div>
                <p className="font-bold text-white mb-1">1302 Edward L. Grant Hwy</p>
                <p>(Aurelia Greene Campus)</p>
                <p>Bronx, NY 10452</p>
              </div>
              <div className="pt-1">
                <a href="tel:718-583-8975" className="hover:text-[#febc04] transition-colors duration-200">
                  (718) 583-8975
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-white/70 text-sm font-medium">
          <p>© 2025 Garden of Learning & Discovery. All rights reserved.</p>
        </div>

        {/* NexSav Credit */}
        <div className="mt-4 pt-4 border-t border-white/5">
          <a
            href="https://nexsav.net"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 text-white/70 hover:text-white/90 transition-all duration-300 group"
          >
            <img
              src="https://nexsav.net/static/media/logo.7ef8f9a8ca3ec946bd31.png"
              alt="NexSav Logo"
              className="h-5 opacity-60 group-hover:opacity-90 transition-opacity duration-300"
            />
            <span className="text-xs font-medium tracking-wide">
              Website designed & developed by <span className="font-semibold">NexSav</span>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
